
import { check, commonApi } from '@/common/index';
import { mapState } from 'vuex';
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import { ValidateRequire,ValidateReallyName } from '@/common/utils/validate.js'
export default {
name: 'Certification',
components: { Group, XInput, XButton },
data() {
return {
name: '',
number: '',
isReady: true,
showTip: false,
}
},
computed: {
...mapState({
UUID: state => state.UUID,
username : state => state.userInfo.userInfo.name,

}),
isNameVerify: () => false
},
watch:{
username(){
if(this.username){
this.name = this.username;
}
}
},
created(){
if(this.username){
this.name = this.username;
}
},
methods: {
haveComTotas(data){
this.$vux.toast.show({ text: data,type: 'cancel'});
},
onBlur(){
this.showTip = false
},
checkForm(){
if (!ValidateReallyName(this.name)) {
this.haveComTotas(this.$t('mine').verifiedAuth.namePlace)
return
}

if (this.isNameVerify && !ValidateRequire(this.number)) {
this.haveComTotas(this.$t('mine').verifiedAuth.IDNOPlace)
return
}

return true
},
confirmRealName() {
if (this.$store.state.userInfo.userInfo.nameValid) { // 表示已经实名认证过
this.haveComTotas(this.$t('mine').verifiedAuth.nameValid)
return
}
if (!this.checkForm()) return
let params = {
UUID: this.UUID,
userName: this.name,
idNumber: this.number,
}
if (this.isReady) {
this.isReady = false;
commonApi.CONFIRM.confirmRealName(params).then(data=>{
this.isReady = true;
this.$store.dispatch('getFirstInfo') 
const { title, successTips1, successTips2 } = this.$t('mine').verifiedAuth
if(data.status == 200){
this.$router.replace({path:'/My/AccountManat',query: { title, desc: successTips1 }})
}else{
this.$router.replace({path:'/My/AccountManat',query: { title, desc: successTips2 }})
}
}).catch(err=>{
this.isReady = true;
this.showTip = true;
this.$vux.toast.show({ text: err, type: 'cancel'});
});
}
},
},
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/AccountManat/VerifiedAuth.vue